import Adal from '../adal/adal-request';
import { CIP_TYPE, encodeData, REST_URL } from '../constants';
import * as types from './actionTypes';

const q = require('q');


export function fetchCipIdeasAction(pageIndex = 1, pageSize = 50, filter = {}) {
  filter = { pageIndex, pageSize, ...filter };
  return ({
    type: types.FETCH_CIP_IDEAS,
    payload: Adal.adalRequest({url: `${REST_URL}cipIdeas?${encodeData(filter)}`})
  });
}

export function fetchCipIdeaAction(id) {
  return ({
    type: types.FETCH_CIP_IDEA,
    payload: Adal.adalRequest({url: `${REST_URL}cipIdeas/${id}`})
  });
}

export function fetchCipGroupsAction(filter) {
  let query = '';
  if (filter) {
    query = `?${encodeData(filter)}`;
  }
  return ({
    type: types.FETCH_CIP_GROUPS,
    payload: Adal.adalRequest({url: `${REST_URL}cipGroups${query}`})
  });
}

export function fetchCipGroupManagersAction() {
  return ({
    type: types.FETCH_CIP_GROUP_MANAGERS,
    payload: Adal.adalRequest({url: `${REST_URL}cipGroups/managers`})
  });
}


export function fetchCipGroupAction(id) {
  return ({
    type: types.FETCH_CIP_GROUP,
    payload: Adal.adalRequest({url: `${REST_URL}cipGroups/${id}`})
  });
}

export function saveCipGroupAction(id, cipGroup) {

  if (id || id >= 0) {
    return ({
      type: types.SAVE_CIP_GROUP,
      payload: Adal.adalRequest({url: `${REST_URL}cipGroups/${id}`, method: 'PUT', data: JSON.stringify(cipGroup)})
    });
  }
  return ({
    type: types.SAVE_CIP_GROUP,
    payload: Adal.adalRequest({url: `${REST_URL}cipGroups`, method: 'POST', data: JSON.stringify(cipGroup)})
  });

}

export function fetchCipDepartmentsAction() {
  return ({
    type: types.FETCH_CIP_DEPARTMENTS,
    payload: Adal.adalRequest({url: `${REST_URL}CipGroupDepartments`})
  });
}


export function fetchCipMembersAction(groupId) {
  return ({
    type: types.FETCH_CIP_MEMBERS,
    payload: Adal.adalRequest({url: `${REST_URL}CipGroups/members/${groupId}`})
  });
}


export function fetchCipTransactionsAction(groupId) {
  return ({
    type: types.FETCH_CIP_GROUP_TRANSACTIONS,
    payload: Adal.adalRequest({url: `${REST_URL}CipGroups/transactions/${groupId}`})
  });
}

export function saveCipTransactionAction(groupId, transaction) {
  return ({
    type: types.SAVE_CIP_TRANSACTION,
    payload: Adal.adalRequest({url: `${REST_URL}CipGroups/transactions/${groupId}`, method: 'POST', data: JSON.stringify(transaction)})
  });
}


export function removeCipMemberAction(groupId, memberId) {
  return ({
    type: types.REMOVE_CIP_MEMBER,
    payload: Adal.adalRequest({url: `${REST_URL}CipGroups/members/${groupId}/${memberId}`, method: 'DELETE'})
  });
}

export function addCipMemberAction(groupId, memberId) {
  return ({
    type: types.ADD_CIP_MEMBER,
    payload: Adal.adalRequest({url: `${REST_URL}CipGroups/members/${groupId}/${memberId}`, method: 'POST'})
  });
}

export function postCipIdeaAction(cipIdea) {
  const deferred = q.defer();
  const Files = cipIdea.Files;

  Adal.adalRequest({url: `${REST_URL}cipIdeas`, method: 'POST', data: JSON.stringify({...cipIdea, Files: null})}).then((payload) => {
    const fd = new FormData();
    if (Files.length > 0) {
      for (let it = 0; it < Files.length; it++) {
        const f = Files[it];
        fd.append(f.name, f);
      }
      Adal.adalRequest({url: `${REST_URL}fileItems/upload/${CIP_TYPE}/${payload.Id}`, method: 'POST', ignoreResponseType: true, ignoreContentType: true, data: fd}).then(() => {
        deferred.resolve(payload);
      }, deferred.reject);
    } else {
      deferred.resolve(payload);
    }
  }, deferred.reject);

  return ({
    type: types.POST_CIP_IDEA,
    payload: deferred.promise
  });
}

export function postCipProgressAction(cipIdeaId, cipProgress) {
  return ({
    type: types.POST_CIP_PROGRESS,
    payload: Adal.adalRequest({url: `${REST_URL}cipIdeas/progress/${cipIdeaId}`, method: 'POST', data: JSON.stringify(cipProgress)})
  });
}



// WEBPACK FOOTER //
// ./actions/cipActions.js